export const getOpenedGroups = (data) => (data.reduce((acc, { id, isSelected = false }) => (Object.assign(Object.assign({}, acc), { [id]: isSelected })), {}));
